import React, {Component} from "react";
import * as THREE from 'three';
import {OrbitControls} from "three/examples/jsm/controls/OrbitControls";
import {DragControls} from "three/examples/jsm/controls/DragControls";
import {FBXLoader} from "three/examples/jsm/loaders/FBXLoader";
import {CSS2DRenderer, CSS2DObject} from 'three-css2drender';
import LoadingCircles from "./LoadingCircles";
import textures from "../externalData/textures";
//import {GUI} from '../dat.gui.module';
import Constants from './Constants';
import {CommonUtil} from "../utils/CommonUtil";
import Stats from "three/examples/jsm/libs/stats.module";

import createjs from 'createjs-module/createjs';
import TwistSticker from "./TwistSticker";
import i18n from 'i18next';

import $ from "jquery";

class CanvasModel extends Component {
    constructor(props) {
        super(props);

        this.zPosition = 15;
        this.initialZoomValue = 1;
        this.zoomShift = 0.1;

        this._mouseListener = this.onMouseMove;
        this._mouse = {
            xPos : 0,
            yPos : 0
        };
        this.draggableId = -1;
        this.baseTextureId = -1;
        this.textureMeshes = [];//[{'mesh : someMesh', 'textureId : -1', textureMaterial : null}, {'mesh : someMesh', 'textureId : -1', textureMaterial : null},]
        this.textureMeshesStatic = [];
        this.material = null;
        this.isDragControlsDeactivated = false;

        this.clock = new THREE.Clock();
        this.mixer = null;
        this.animElapsedTime = null;
        this.animTimeDiff = 0;
        this.start = null;
        this.labelDiv = null;
        this.isAnimationDirectionForward = false;
        this.lightMapActivator = null;

        this.shadowConfig = {
            shadowCameraVisible: false,
            shadowCameraNear: 750,
            shadowCameraFar: 4000,
            shadowCameraFov: 33,
            shadowBias: - 0.0002
        };

        this.state = {
            model3D : null,
            modelsClicked : 0,
            isTwistLabelVisible : false,
            isTwistingComplete : false,
            isMouseInsideCanvas : true,
            orientationAngle : 0,
            isBgExist: false
        };
    }

    componentDidMount() {
        this.sceneSetup();
        this.reLoadModel();
        this.loadLights();

        //inactive until fist loaded model is twisted one turn around
        this.dragControls.deactivate();
        this.controls.enabled = false;

        window.addEventListener('resize', this.handleWindowResize);
        window.addEventListener('orientationchange', this.onOrienationChange);

        document.getElementById("modelCanvas").addEventListener("mouseenter", this.onCanvasMouseIn);
        document.getElementById("modelCanvas").addEventListener("touchmove", this.onCanvasMouseIn);

        document.getElementById("modelCanvas").addEventListener("mouseout", this.onCanvasMouseOut);
        document.getElementById("modelCanvas").addEventListener("touchcancel", this.onCanvasMouseOut);

        i18n.on('languageChanged', function(lng) {
            console.log('LANG iS : ' + lng);
            this.reLoadAnimationLabel(true);
        }.bind(this));
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.textureId !== prevProps.textureId) {
            this.loadTexture();
        }
        if (this.props.selectedModel !== prevProps.selectedModel) {
            //console.log('loadModel: ' + this.props.selectedModel.path);
            this.setState({
                modelsClicked : this.state.modelsClicked + 1
            });
            this.baseTextureId = -1;
            this.reLoadModel();
            this.loadLights();
        }
        if (this.props.isTextureDragging !== prevProps.isTextureDragging) {
            this.activateTextureDragging(this.props.isTextureDragging);
        }
        if(prevState.model3D !== this.state.model3D && this.state.modelsClicked === 0){
            this.twistModel();
        }
        if(prevState.isTwistingComplete !== this.state.isTwistingComplete){
            document.getElementById('modelCanvas').addEventListener("mousedown", this.onCanvasTouchStart);
            document.getElementById('modelCanvas').addEventListener('mouseup', this.onCanvasTouchEnd);
            document.getElementById('modelCanvas').addEventListener('touchstart', this.onCanvasTouchStart);
            document.getElementById('modelCanvas').addEventListener('touchend', this.onCanvasTouchEnd);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowResize);
        window.removeEventListener('orientationchange', this.onOrienationChange);

        document.getElementById("modelCanvas").removeEventListener("mouseenter", this.onCanvasMouseIn);
        document.getElementById("modelCanvas").removeEventListener("touchmove", this.onCanvasMouseIn);

        document.getElementById("modelCanvas").removeEventListener("mouseout", this.onCanvasMouseOut);
        document.getElementById("modelCanvas").removeEventListener("touchcancel", this.onCanvasMouseOut);

        document.getElementById('modelCanvas').removeEventListener("mousedown", this.onCanvasTouchStart);
        document.getElementById('modelCanvas').removeEventListener('mouseup', this.onCanvasTouchEnd);
        document.getElementById('modelCanvas').removeEventListener('touchstart', this.onCanvasTouchStart);
        document.getElementById('modelCanvas').removeEventListener('touchend', this.onCanvasTouchEnd);

        window.cancelAnimationFrame(this.animationID);
        this.controls.dispose();
        this.reInitializeDragObject();
        this.mount.removeChild(this.renderer.domElement);
        this.mount.removeChild(this.labelRenderer.domElement);
        this.baseTextureId = -1;
        this.setState = {
            model3D : null,
            modelsClicked : 0,
            isBgExist: false
        };
    }

    onCanvasTouchStart = (e) => {
        CommonUtil.manageVisibility(false,
            ['.topControlsContainer', '.animLabelContainer']);

        if(CommonUtil.isMobile()) {
            // manage possible 2 touches here
            if(e.targetTouches) {
                switch (e.targetTouches.length) {
                    case 1:
                        //document.getElementById('modelsContainer').style.background = "pink";
                        break;
                    case 2:
                        //document.getElementById('modelsContainer').style.background = "blue";
                        this.dragControls.deactivate();
                        this.isDragControlsDeactivated = true;
                        this.controls.enabled = true;
                        break;
                    default: console.log("Not supported"); break;
                }
            }
        } else {
            this.controls.enabled = true;
        }
    };

    onCanvasTouchEnd = (e) => {
        CommonUtil.manageVisibility(true,
            ['.topControlsContainer', '.animLabelContainer']);
        if(this.isDragControlsDeactivated){
            this.isDragControlsDeactivated = false;
            this.dragControls.activate();
        }
    };

    onCanvasMouseIn = (event) => {
        console.log('__IN_ : ', CommonUtil.isMobile(), event.target.id, event.currentTarget.id);
        if(CommonUtil.isMobile()) {
            if(!$('.wrapperContainer').has($(event.target)).length) {
                console.log('== IN');
            } else {
                console.log('== OUT');
            }
        }
        this.setState({isMouseInsideCanvas : true});
    };

    onOrienationChange = (event) => {
        setTimeout(this.reScaleCanvas, 50, event);
    };

    reScaleCanvas = (event) => {
        this.setState({
            orientationAngle : event.target.screen.orientation.angle
        });
        console.log('angle : ' + this.state.orientationAngle);
        this.handleWindowResize();
    };

    setDocumentVariable = (propertyName, value) => {
        document.documentElement.style.setProperty(propertyName, value);
    };

    onCanvasMouseOut = () => {
        console.log('__OUT');
        this.setState({isMouseInsideCanvas : false})
    };

    reInitializeDragObject = () => {
        this.dragobjects = [];
        this.dragControls = new DragControls( this.dragobjects, this.camera, this.mount );
        this.dragControls.addEventListener( 'dragstart', () => {
            //console.log('DRAG_START : ' + ' : isMobile=' + CommonUtil.isMobile());
            this.controls.enabled = false;
        });

        this.dragControls.addEventListener( 'dragend', function (event) {
            //console.log('END ', this.controls.enabled);
            if(this.state.isMouseInsideCanvas && !this.controls.enabled){
                this.controls.enabled = true;
            }
        }.bind(this) );

        this.dragControls.addEventListener ( 'drag', function( event ){
            console.log('dragging ', event.object.position.y);
            /*
            * prevent moving model to top, so it's impossible to look underneath
            * */
            let yLimit = (this.state.orientationAngle === 90) ? 20 : 0;
            if(event.object.position.y > yLimit){
                event.object.position.y = yLimit;
            }

            this.groundPlane.position.y = event.object.position.y;

        }.bind(this) );
    };

    twistModel = () =>  {
        if(this.state.model3D){
            /*
            * example: https://www.youtube.com/watch?v=aUYLYww20wM
            * */
            let obj = this.state.model3D;

            this.setState({
                isTwistLabelVisible : true
            });
            new createjs.Tween(obj.rotation, {loop : false})
                .wait(Constants.TWIST_WAIT_TIME * 0.3)
                .to({y: 2 * Math.PI}, Constants.TWIST_WAIT_TIME * 1.5, createjs.Ease.backInOut)
                .wait(Constants.TWIST_WAIT_TIME * 0.3)
                .call(handleComplete.bind(this))
            ;
            function handleComplete() {
                this.controls.enabled = true;
                this.dragControls.activate();
                this.setState({
                    isTwistLabelVisible : false,
                    isTwistingComplete : true
                });
                this.props.onTwistingComplete();
            }
            createjs.Ticker.framerate = 60;
        }
    };

    reLoadModel = () => {
        this.clearScene(this.scene);
        this.reSetProperties();
        this.deactivateControls();
        this.reInitializeDragObject();
        this.loadModel();
        setTimeout(() => {
            this.activateControls();
        },500);
        this.rePositionCamera();

        /*this.stats.end();
        this.stats.begin();*/
    };

    rePositionCamera = () => {
        this.camera.position.set( -70, 30, 110 );
    };

    clearScene = (obj) => {
        while(obj.children.length > 0){
            this.clearScene(obj.children[0]);
            obj.remove(obj.children[0]);
        }
        if(obj.geometry) obj.geometry.dispose();

        if(obj.material){
            //in case of map, bumpMap, normalMap, envMap ...
            Object.keys(obj.material).forEach(prop => {
                if(!obj.material[prop])
                    return;
                if(typeof obj.material[prop].dispose === 'function')
                    obj.material[prop].dispose()
            });
            if(typeof obj.material.dispose === 'function')
                obj.material.dispose()
        }
        this.renderer.dispose();
        //this.labelRenderer.dispose();
    };

    reSetProperties = () => {
        this.clock = new THREE.Clock();
        this.mixer = null;
        this.animElapsedTime = null;
        this.animTimeDiff = 0;
        this.labelDiv = null;
        this.isAnimationDirectionForward = false;
        this.lightMapActivator = null;
    };

    // Standard scene setup in Three.js. Check "Creating a scene" manual for more information
    // https://threejs.org/docs/#manual/en/introduction/Creating-a-scene
    sceneSetup = () => {
        // get container dimensions and use them for scene sizing
        const width = parseInt(getComputedStyle(this.mount).width);
        const height = parseInt(width / Constants.DIMMENSIONS_RATIO);//parseInt(getComputedStyle(this.mount).height) - 2;

        console.log(width + ' :: ' + height);

        this.raycaster = new THREE.Raycaster();
        this.mouse = new THREE.Vector2();
        this.intersectedObject = null;

        this.scene = new THREE.Scene();
        this.scene.background = new THREE.Color( Constants.SCENE_BG_COLOR_AT_LOADING );
        this.camera = new THREE.PerspectiveCamera(
            40, // fov = field of view
            width / height, // aspect ratio
            0.1, // near plane
            5000 // far plane
        );
        console.log('000000000 : ' + width + ' : ' + height);
        this.rePositionCamera();

        this.renderer = new THREE.WebGLRenderer({antialias: true, alpha: true, preserveDrawingBuffer: true});
        this.renderer.setPixelRatio( window.devicePixelRatio );
        this.renderer.setSize( width, height );
        this.renderer.shadowMap.enabled = true;
        this.renderer.shadowMap.type = THREE.PCFSoftShadowMap;
        this.renderer.domElement.id = 'modelCanvas';

        this.mount.appendChild( this.renderer.domElement ); // mount using React ref
        this.createImageBgCanvas();

        this.labelRenderer = new CSS2DRenderer();
        this.labelRenderer.setSize( width, height );
        this.labelRenderer.domElement.style.position = 'absolute';
        this.mount.appendChild( this.labelRenderer.domElement );

        // OrbitControls allow a camera to orbit around the object
        // https://threejs.org/docs/#examples/controls/OrbitControls
        this.controls = new OrbitControls( this.camera, this.mount );
        //this.controls.target.set( 0, 10,  0);

        //in order to prevent placing camera under ground floor we need to restrict polarAngle
        this.controls.maxPolarAngle = this.controls.maxPolarAngle / 2;
        this.controls.minDistance = 60;
        this.controls.maxDistance = 400;

        this.controls.enableDamping = true;
        this.controls.dampingFactor = 0.07;

        /*https://habr.com/ru/post/224509/*/
        //this.initStats();

        /*//GROUND
        var planeGeometry = new THREE.PlaneGeometry( 1000, 1000 );
        planeGeometry.rotateX( - Math.PI / 2 );
        var planeMaterial = new THREE.ShadowMaterial( { opacity: 0.3 } );

        this.groundPlane = new THREE.Mesh( planeGeometry, planeMaterial );
        this.groundPlane.position.y = - 15;
        this.groundPlane.receiveShadow = true;
        this.scene.add( this.groundPlane );*/
    };

    initStats = () => {
        this.stats = new Stats();
        this.stats.setMode(0);
        this.stats.domElement.className = 'stats';

        this.mount.append(this.stats.domElement );
        return this.stats;
    };

    createImageBgCanvas = () => {
        let imageBgContainer = document.createElement("div");
        imageBgContainer.setAttribute("id", "imageBgContainer");
        imageBgContainer.setAttribute("class", "imageBgContainer mx-auto");
        document.getElementById('canvasContainer').appendChild(imageBgContainer);

        let imageBgCanvas = document.createElement("canvas");
        imageBgCanvas.setAttribute("id", "imageBgCanvas");
        imageBgContainer.appendChild(imageBgCanvas);
    };

    loadLights = () => {
        this.ambientLight = new THREE.AmbientLight( 0xffffff, 0.25);
        this.ambientLight.position.set( 0, 50, 0 );
        this.ambientLight.userData = { keepMe: true };
        this.scene.add( this.ambientLight );

        this.dirLight = new THREE.DirectionalLight( 0xffffff, 0.28 );
        this.dirLight.position.set( 0, 1000, 25 );
        this.dirLight.target.position.set( 50, 0, 0 );
        this.dirLight.castShadow = true;
        this.dirLight.shadow = new THREE.LightShadow( new THREE.PerspectiveCamera(
            this.shadowConfig.shadowCameraFov, 1, this.shadowConfig.shadowCameraNear, this.shadowConfig.shadowCameraFar ) );
        this.dirLight.shadow.bias = this.shadowConfig.shadowBias;
        //this.dirLight.shadow.radius = 8;
        this.dirLight.shadow.mapSize = new THREE.Vector2(512, 512);
        this.dirLight.userData = { keepMe: true };

        this.scene.add( this.dirLight );
        this.scene.add( this.dirLight.target );

        /*this.ambientLightHelper = new THREE.HemisphereLightHelper( this.ambientLight, 10, 0x000FFF );
        this.scene.add( this.ambientLightHelper );

        this.dirLightHelper = new THREE.DirectionalLightHelper( this.dirLight, 10, 0xFF0000);
        this.scene.add( this.dirLightHelper );

        const gui = new GUI();
        gui.add(this.dirLight, 'intensity', 0, 2, 0.01);
        this.makeXYZGUI(gui, this.dirLight.position, 'position', this.updateLight);
        this.makeXYZGUI(gui, this.dirLight.target.position, 'target', this.updateLight);

        const gui2 = new GUI();
        gui2.add(this.ambientLight, 'intensity', 0, 2, 0.01);
        this.makeXYZGUI(gui2, this.ambientLight.position, 'position', this.updateLight);*/

        // SHADOW CAMERA HELPER
        /*this.shadowCameraHelper = new THREE.CameraHelper( this.dirLight.shadow.camera );
        this.shadowCameraHelper.visible = this.shadowConfig.shadowCameraVisible;
        this.scene.add( this.shadowCameraHelper );

        // GUI
        const gui = new GUI();
        // SHADOW
        var shadowGUI = gui.addFolder( "Shadow" );
        shadowGUI.add( this.shadowConfig, 'shadowCameraVisible' ).onChange( function () {
            this.shadowCameraHelper.visible = this.shadowConfig.shadowCameraVisible;
        }.bind(this) );
        shadowGUI.add( this.shadowConfig, 'shadowCameraNear', 1, 1500 ).onChange( function () {
            this.dirLight.shadow.camera.near = this.shadowConfig.shadowCameraNear;
            this.dirLight.shadow.camera.updateProjectionMatrix();
            this.shadowCameraHelper.update();
        }.bind(this) );
        shadowGUI.add( this.shadowConfig, 'shadowCameraFar', 1501, 5000 ).onChange( function () {
            this.dirLight.shadow.camera.far = this.shadowConfig.shadowCameraFar;
            this.dirLight.shadow.camera.updateProjectionMatrix();
            this.shadowCameraHelper.update();
        }.bind(this) );
        shadowGUI.add( this.shadowConfig, 'shadowCameraFov', 1, 220 ).onChange( function () {
            this.dirLight.shadow.camera.fov = this.shadowConfig.shadowCameraFov;
            this.dirLight.shadow.camera.updateProjectionMatrix();
            this.shadowCameraHelper.update();
        }.bind(this) );
        shadowGUI.add( this.shadowConfig, 'shadowBias', - 0.01, 0.01 ).onChange( function () {
            this.dirLight.shadow.bias = this.shadowConfig.shadowBias;
        }.bind(this) );
        shadowGUI.open();*/

        this.loadGroundMesh();
    };

    loadGroundMesh = () => {
        var planeGeometry = new THREE.PlaneGeometry( 500, 500, 5, 5 );
        planeGeometry.rotateX( - Math.PI / 2 );
        var planeMaterial = new THREE.ShadowMaterial( { opacity: 0.15 } );

        this.groundPlane = new THREE.Mesh( planeGeometry, planeMaterial );
        this.groundPlane.position.y = - 15;
        this.groundPlane.receiveShadow = true;
        this.scene.add( this.groundPlane );
    };

    makeXYZGUI = (gui, vector3, name, onChangeFn) => {
        const folder = gui.addFolder(name);
        folder.add(vector3, 'x', -80, 80).onChange(onChangeFn);
        folder.add(vector3, 'y', -80, 80).onChange(onChangeFn);
        folder.add(vector3, 'z', -80, 80).onChange(onChangeFn);
        folder.open();
    };

    updateLight = () => {
        this.dirLight.target.updateMatrixWorld();

        this.dirLightHelper.update();
        this.ambientLightHelper.update();
    };

    removePreviousModel = () => {
        if(this.state.model3D){
            this.material.dispose();
            this.scene.remove(this.state.model3D);
            this.setState({
                model3D : null
            });
        }
    };

    activateTextureDragging = (value = false) => {
        if(value) {
            window.addEventListener( 'mousemove', this._mouseListener, false );
            window.addEventListener( 'touchmove', this._mouseListener, false );
        } else {
            window.removeEventListener( 'mousemove', this._mouseListener, false );
            window.removeEventListener( 'touchmove', this._mouseListener, false );
            this.shouldMeshToBeUpdated();
        }
    };

    loadTexture = async () => {
        let selectedItem = textures.find((someTexture) => Boolean(Number(someTexture.id) === Number(this.props.textureId)) ? someTexture : null);
        console.log('selectedItem : ' + selectedItem + ' : ' + selectedItem.path);
        this.baseTextureId = selectedItem.id;
        await this.applyTextureLoader(Constants.ON_REDRAW_ALL_TEXTURES, selectedItem);
    };

    shouldMeshToBeUpdated = () => {
        let intersects = this.getCursorIntersectionWithAnyMesh();
        this.intersectedObject = null;
        if(intersects.length > 0){
            let draggedItem = textures.find(someTexture => Boolean(parseInt(someTexture.id) === Number(this.draggableId)) ? someTexture : null);
            this.applyTextureLoader(Constants.ON_DRAG_TEXTURE_END, draggedItem);
        }
    };

    onMouseMove = (event) => {
        if(event instanceof MouseEvent){
            this._mouse.xPos = event.clientX;
            this._mouse.yPos = event.clientY;
        } else if(event instanceof TouchEvent) {
            this._mouse.xPos = event.changedTouches[0].clientX;
            this._mouse.yPos = event.changedTouches[0].clientY;
        }

        let intersects = this.getCursorIntersectionWithAnyMesh();
        if(intersects.length > 0){
            console.log('move_name :: '  + intersects.length + ' : ' + intersects[ 0 ].object.name + ' : ' + this.draggableId);

            let currentIntersectedObject;
            switch(intersects[ 0 ].object.name){
                case 'base' :
                case 'base_1' :
                case 'base_2' :
                case 'base_3' :
                case 'cushion' :
                    currentIntersectedObject = intersects[ 0 ].object;
                    console.log('== ', this.intersectedObject, currentIntersectedObject.name);
                    if(this.intersectedObject === null || currentIntersectedObject.name !== this.intersectedObject.name){
                        let temporaryTextureId = this.draggableId;
                        let intersectedTexture = textures.find((someTexture) => Boolean(parseInt(someTexture.id) === Number(temporaryTextureId)) ? someTexture : null);
                        this.applyTextureLoader(Constants.ON_DRAG_TEXTURE, intersectedTexture, currentIntersectedObject);
                    }
                    this.intersectedObject = currentIntersectedObject;
                    break;

                default:
                    currentIntersectedObject = null;
                    break;
            }
        } else {
            this.intersectedObject = null;
            this.reDrawAllTextures(false);
            //this.callRender();
        }
    };

    applyTextureLoader = async (action, selectedTexture, currentIntersectedObject = null) => {
        let loader = new THREE.TextureLoader();
        loader.setCrossOrigin(true);
        let draggedMaterial;
        let intersects = this.getCursorIntersectionWithAnyMesh();

        const lightMapLoader = async function(lightMap) {
            await loader.loadAsync( selectedTexture.path).then(
                ( texture ) => {
                    texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
                    texture.repeat.set( selectedTexture.meshParameter, selectedTexture.meshParameter, selectedTexture.meshParameter);
                    texture.anisotropy = 0;
                    texture.magFilter = THREE.NearestFilter;
                    texture.rotation = Math.PI / 8;

                    let material = new THREE.MeshLambertMaterial({
                        map: texture,
                        side: THREE.DoubleSide,
                        lightMap: lightMap,
                        wireframe: false,
                    });

                    let objectToUpdate;
                    switch(action){
                        case Constants.ON_REDRAW_ALL_TEXTURES :
                            this.material = material;
                            this.reDrawAllTextures(true, true);
                            break;

                        case Constants.ON_DRAG_TEXTURE_END :
                            draggedMaterial = material;
                            let intersectedObject;
                            switch(intersects[ 0 ].object.name){
                                case 'base' :
                                case 'base_1' :
                                case 'base_2' :
                                case 'base_3' :
                                case 'cushion' :
                                    intersectedObject = intersects[ 0 ].object;
                                    break;
                                default:
                                    intersectedObject = null;
                                    break;
                            }
                            objectToUpdate = this.textureMeshes.find(obj => obj.mesh.name === intersectedObject.name);
                            objectToUpdate.mesh.material = draggedMaterial;
                            objectToUpdate.mesh.material.needsUpdate = true;
                            objectToUpdate.textureId = Number(this.draggableId);
                            objectToUpdate.textureMaterial = draggedMaterial;
                            break;

                        case Constants.ON_DRAG_TEXTURE :
                            draggedMaterial = material;
                            this.reDrawAllTextures(false);
                            objectToUpdate = this.textureMeshes.find(obj => obj.mesh.name === currentIntersectedObject.name);
                            objectToUpdate.mesh.material = draggedMaterial;
                            objectToUpdate.mesh.material.needsUpdate = true;
                            break;

                        default:
                            break;
                    }
                    //this.callRender();
                }
            ).catch(error => alert('Error : ' + error));
        }.bind(this);

        if(this.isAnimationDirectionForward) {
            await new THREE.TextureLoader().loadAsync(this.props.selectedModel.lightMapPathAnim).then(
                (lightMap) => {
                    return lightMapLoader(lightMap)
                }
            ).catch(error => alert('Error : ' + error));
        } else {
            await new THREE.TextureLoader().loadAsync(this.props.selectedModel.lightMapPath).then(
                (lightMap) => {
                    return lightMapLoader(lightMap)
                }
            ).catch(error => alert('Error : ' + error));
        }
    };

    getCursorIntersectionWithAnyMesh = () => {
        const modelsContainer = document.getElementById("modelsContainer");
        const mql = window.matchMedia("(orientation: portrait)");
        let centeredContainer;

        if(mql.matches){
            // Portrait orientation
            centeredContainer = document.getElementById("rootContainer");
        } else {
            // Landscape orientation
            let rootContainerHeight = document.getElementById('rootContainer').clientHeight;
            let modelCanvasHeight = document.getElementById('modelCanvas').clientHeight;
            console.log(rootContainerHeight + ' :: ' + modelCanvasHeight);
            if(Math.abs(rootContainerHeight - modelCanvasHeight) < 5){
                centeredContainer = document.getElementById("canvasContainer");
            } else {
                //in case if iPad-pro
                centeredContainer = document.getElementById("rootContainer");
            }
        }

        const wrapperContainerHeight = document.getElementById("wrapperContainer").clientHeight;
        const height = parseInt(getComputedStyle(this.mount).height);
        let shiftYTop = modelsContainer.clientHeight;
        let shiftX = centeredContainer.offsetLeft;
        let shiftY = centeredContainer.offsetTop + shiftYTop;
        let heightRatio = wrapperContainerHeight / height;

        this.mouse.x = ((this._mouse.xPos - shiftX) / (document.documentElement.clientWidth - 2 * shiftX)) * 2 - 1;
        this.mouse.y = - ((this._mouse.yPos - shiftY ) * heightRatio / (document.documentElement.clientHeight - 2 * shiftY + shiftYTop)) * 2 + 1;

        // update the picking ray with the camera and mouse position
        this.raycaster.setFromCamera( this.mouse, this.camera );
        let allMeshes = this.textureMeshes.map(obj => obj.mesh);
        let intersections = this.raycaster.intersectObjects( allMeshes );

        console.log(' MOVE : ' + mql.matches + ' ~ ' + centeredContainer.id + ' : ' + this.mouse.x + ' : ' + this.mouse.y + ' :: ' + this._mouse.xPos + ':' + this._mouse.yPos + ' ** ' + shiftX + ':' + shiftY + " : " + shiftYTop + ' :: ' + window.innerHeight + ' : ' + intersections.length);
        return intersections;
    };

    reDrawAllTextures = (discardTextureByIdCheck = true, twistModel = false) => {
        //apply all meshes material textures to default ones
        if(discardTextureByIdCheck){
            if(this.textureMeshes.length > 0){
                this.textureMeshes.forEach(obj => {
                    console.log('DISCARD_');
                    obj.textureId = -1;
                    obj.textureMaterial = null;
                    obj.mesh.material = this.material;
                    obj.mesh.material.needsUpdate = true;
                });
            }
        } else {
            if(this.textureMeshes.length > 0){
                let notUpdatedBeforeMeshes = this.textureMeshes.filter(obj => Number(obj.textureId) === -1);
                notUpdatedBeforeMeshes.forEach(obj => {
                    //console.log('NAME : ' + obj.mesh.name + ' : ' + obj.textureId);
                    obj.mesh.material = this.material;
                    obj.mesh.material.needsUpdate = true;
                });

                let updatedBeforeMeshes = this.textureMeshes.filter(obj => Number(obj.textureId) !== -1);
                updatedBeforeMeshes.forEach(obj => {
                    obj.mesh.material = obj.textureMaterial;
                    obj.mesh.material.needsUpdate = true;
                });
            }
        }
    };

    applyStaticTextures = () => {
        let material;

        const setMaterial = function(materialName, material) {
            this.textureMeshesStatic.filter(obj => obj.name === materialName).forEach(obj => {
                obj.mesh.material = material;
                obj.mesh.material.needsUpdate = true;
            });
        }.bind(this);

        let applyTexture = (materialName, materialUrl, lightMapUrl = null, rotation = null) => {
            switch(materialName){
                case Constants.THREADS :
                case Constants.THREADS_1 :
                case Constants.THREADS_2 :
                    new THREE.TextureLoader().loadAsync(lightMapUrl).then(lightMaps => {
                        new THREE.TextureLoader().loadAsync( materialUrl ).then(map => {
                            map.wrapS = map.wrapT = THREE.RepeatWrapping;
                            map.repeat.set( 1, 1, 1 );
                            map.anisotropy = 16;
                            map.magFilter = THREE.NearestFilter;

                            material = new THREE.MeshPhongMaterial( {
                                map: map,
                                side: THREE.DoubleSide,
                                lightMap: lightMaps,
                                transparent: true,
                                opacity : 0.7
                            });
                            setMaterial(materialName, material);
                        }).catch(error => {
                            alert('An error is happened : '+error);
                        });
                    }).catch(error => {
                        alert('An error is happened : '+error);
                    });
                    break;

                case Constants.ARMREST :
                    new THREE.TextureLoader().loadAsync( materialUrl ).then(map => {
                        map.wrapS = map.wrapT = THREE.RepeatWrapping;
                        map.repeat.set( 30, 20, 20 );
                        map.anisotropy = 16;
                        map.rotation = rotation;

                        material = new THREE.MeshPhysicalMaterial( {
                            map: map,
                            side: THREE.DoubleSide,
                            roughness : 0.2,
                            metalness : 0,
                            reflectivity : 0.2,
                            clearcoat : 0.2,
                            clearcoatRoughness : 0.3
                        });
                        setMaterial(materialName, material);
                    }).catch(error => {
                        alert('An error is happened : '+error);
                    });
                    break;

                case Constants.LABEL :
                    new THREE.TextureLoader().loadAsync(lightMapUrl).then(lightMaps => {
                        new THREE.TextureLoader().loadAsync( materialUrl ).then(map => {
                            map.wrapS = map.wrapT = THREE.RepeatWrapping;
                            map.repeat.set( 1, 1, 1 );
                            map.anisotropy = 16;
                            map.magFilter = THREE.NearestFilter;

                            material = new THREE.MeshPhongMaterial( {
                                map: map,
                                side: THREE.DoubleSide,
                                lightMap: lightMaps,
                                transparent: false
                            });
                            setMaterial(materialName, material);
                        }).catch(error => {
                            alert('An error is happened : '+error);
                        });
                    }).catch(error => {
                        alert('An error is happened : '+error);
                    });
                    break;

                case Constants.SUPPORT :
                    new THREE.TextureLoader().loadAsync(lightMapUrl).then(lightMaps => {
                        new THREE.TextureLoader().loadAsync( materialUrl ).then(map => {
                            map.wrapS = map.wrapT = THREE.RepeatWrapping;
                            map.repeat.set( 100, 10, 10);
                            map.anisotropy = 0;
                            map.rotation = rotation;

                            new THREE.TextureLoader().loadAsync('/models/fbx/envMaps/karmenEnvMap.png').then(envMap => {
                                envMap.mapping = THREE.UVMapping;

                                material = new THREE.MeshPhysicalMaterial( {
                                    map: map,
                                    lightMap: lightMaps,
                                    envMap : envMap,
                                    side: THREE.DoubleSide,
                                    roughness : 0.06,
                                    metalness : 0.23,
                                    reflectivity : 1,
                                    clearcoat : 1,
                                    combine: THREE.MultiplyOperation
                                });
                                setMaterial(materialName, material);
                            }).catch(error => {
                                alert('An error is happened : '+error);
                            });

                        }).catch(error => {
                            alert('An error is happened : '+error);
                        });

                    }).catch(error => {
                        alert('An error is happened : '+error);
                    });
                    break;
                default: break;
            }
        };

        if(this.textureMeshesStatic && this.textureMeshesStatic.length > 0){
            let selectedModel = this.props.selectedModel;
            switch (selectedModel.name) {
                case 'Karina':
                    applyTexture(
                        Constants.ARMREST,
                        selectedModel.armrestPath,
                        null,
                        Math.PI / 2);
                    /*let gui = new GUI();
                    gui.add( material, 'roughness', 0, 1 ).step( 0.01 );
                    gui.add( material, 'metalness', 0, 1 ).step( 0.01 );
                    gui.add( material, 'reflectivity', 0, 1 ).step( 0.01 );
                    gui.add( material, 'clearcoat', 0, 1 ).step( 0.01 );
                    gui.add( material, 'clearcoatRoughness', 0, 1 ).step( 0.01 );*/
                    break;

                case 'Sharman':
                    //apply threads
                    applyTexture(
                        Constants.THREADS,
                        selectedModel.threadsPath,
                        selectedModel.threadsLightMapPath);

                    applyTexture(
                        Constants.ARMREST,
                        selectedModel.armrestPath);
                    break;

                case 'Meriland':
                    if(selectedModel.isAnimated === 'true'){
                        applyTexture(
                            Constants.THREADS_1,
                            selectedModel.threadsPath,
                            selectedModel.threadsLightMapPath);
                        applyTexture(
                            Constants.THREADS_2,
                            selectedModel.threadsPath,
                            selectedModel.threadsLightMapPath);
                    } else {
                        applyTexture(
                            Constants.THREADS,
                            selectedModel.threadsPath,
                            selectedModel.threadsLightMapPath);
                    }
                    break;

                case 'Karmen':
                    applyTexture(
                        Constants.THREADS,
                        selectedModel.threadsPath,
                        selectedModel.threadsLightMapPath);
                    applyTexture(
                        Constants.LABEL,
                        selectedModel.labelPath,
                        selectedModel.labelLightMapPath);
                    applyTexture(
                        Constants.ARMREST,
                        selectedModel.armrestPath,
                        null,
                        Math.PI / 2);
                    applyTexture(
                        Constants.SUPPORT,
                        selectedModel.supportPath,
                        selectedModel.supportLightMapPath);
                    break;

                default: break;
            }
        }
    };

    loadModel = async () => {
        this.removePreviousModel();
        let manager = new THREE.LoadingManager();
        await this.loadTexture();

        const managerOnStart = function () {
            console.log( 'STARTED LOADING FILE__');
            this.scene.background = new THREE.Color( Constants.SCENE_BG_COLOR_AT_LOADING );

            CommonUtil.manageVisibility(true,['#loading-overlay']);
            CommonUtil.manageVisibility(false,
                ['#allControlsContainer', '#texturesContainer', '#descriptionsTextsContainer', '#imageBgContainer']);
        }.bind(this);

        const managerOnLoad = function () {
            console.log( 'Loading complete!');
            this.scene.background = (!this.state.isBgExist) ? new THREE.Color( Constants.SCENE_BG_COLOR_AFTER_LOADING ) : null;

            CommonUtil.manageVisibility(false,['#loading-overlay']);
            CommonUtil.manageVisibility(true,
                ['#allControlsContainer', '#texturesContainer', '#descriptionsTextsContainer', '#imageBgContainer']);
            this.applyStaticTextures();
        }.bind(this);

        const managerOnError = function ( e ) {
            alert( 'There was an error loading ' + e );
        };

        let loader = new FBXLoader(manager);
        this.textureMeshes = [];
        this.textureMeshesStatic = [];
        managerOnStart();

        loader.loadAsync(this.props.selectedModel.path).then(
            object3d  => {
                object3d.traverse( child => {
                    if ( child.isMesh ) {
                        child.castShadow = true;
                        child.receiveShadow = false;
                        //
                        // Next two lines are responsible for proper laying
                        // lightMap on whole 3D model
                        //
                        if(child.geometry && child.geometry.attributes && child.geometry.attributes.uv && child.geometry.attributes.uv.array &&
                            child.name !== 'threads' && child.name !== 'threads_1' && child.name !== 'threads_2' && child.name !== 'label' && child.name !== 'support1') {

                            let uvs = child.geometry.attributes.uv.array;
                            child.geometry.attributes.uv2 = new THREE.BufferAttribute( uvs, 2 );
                        }

                        console.log('child.name', child.name);
                        let obj;
                        switch (child.name) {
                            case 'base':
                            case 'base_1':
                            case 'base_2':
                            case 'base_3':
                            case 'cushion':
                                let textureMesh = child;
                                textureMesh.material = this.material;
                                obj = {
                                    mesh: textureMesh,
                                    textureId : -1,
                                    textureMaterial : null
                                };
                                this.textureMeshes.push(obj);
                                break;

                            case 'armrest':
                            case 'threads':
                            case 'threads_1':
                            case 'threads_2':
                            case 'label':
                            case 'support':
                                console.log('name', child.name);
                                obj = {
                                    name: child.name,
                                    mesh: child
                                };
                                this.textureMeshesStatic.push(obj);
                                break;

                            default :
                                break;
                        }
                    }
                });

                object3d.position.set( 0, -this.zPosition, 0 );
                object3d.scale.setScalar( this.props.selectedModel.scaleFactor );

                this.setState({
                    model3D : object3d
                });

                this.dragobjects.push(this.state.model3D);
                this.scene.add( this.state.model3D );
                if(this.props.selectedModel.isAnimated === 'true'){
                    this.reLoadAnimationLabel();
                }

                managerOnLoad();
            }).catch(
            error => managerOnError(error)
        );
    };

    reLoadAnimationLabel = (cleanDiv = false) => {
        //https://www.npmjs.com/package/three-css2drender
        if(cleanDiv){
            CommonUtil.removeAllChildrenFromNode(this.labelDiv);
        }
        if(!this.labelDiv){
            this.labelDiv = document.createElement( 'div' );
            this.labelDiv.className = 'animLabelContainer';

            let label = new CSS2DObject( this.labelDiv );
            this.labelDiv.parent = label;

            let pos = this.props.selectedModel.animatedLabelPosition;
            label.position.set( pos[0], pos[1], pos[2] );
            this.state.model3D.add( label );

            $(label.element).on('touchstart click', function(clickedLabel) {
                this.isAnimationDirectionForward = !this.isAnimationDirectionForward;
                this.startAnimation(this.isAnimationDirectionForward);

                if(Constants.HOST_WEBSITE === 'ddn'){
                    clickedLabel.element.children[0].textContent = !this.isAnimationDirectionForward ? 'lock_open' : 'lock_outline';
                } else {
                    clickedLabel.element.textContent = !this.isAnimationDirectionForward ? this.props.translation('ANIMATION_FOLD_OUT_TITLE') : this.props.translation('ANIMATION_FOLD_IN_TITLE');
                }
            }.bind(this, label));
        }

        if(Constants.HOST_WEBSITE === 'ddn'){
            let icon = document.createElement( 'i' );
            icon.className = 'material-icons';
            icon.textContent = 'lock_open';
            this.labelDiv.append(icon);
        } else {
            this.labelDiv.textContent = this.props.translation('ANIMATION_FOLD_OUT_TITLE');
        }
    };

    startAnimation = (isDirectionForward) => {
        if(this.lightMapActivator) {
            clearTimeout(this.lightMapActivator);
        }
        //https://gist.github.com/rtpHarry/2d41811d04825935039dfc075116d0ad
        let object3d = this.state.model3D;
        this.mixer = new THREE.AnimationMixer( object3d );
        let action = this.mixer.clipAction( object3d.animations[ 0 ] );

        action.clampWhenFinished = true;
        action.loop = THREE.LoopOnce;
        action.timeScale = (this.isAnimationDirectionForward) ? 1 : -1;

        if(!this.isAnimationDirectionForward){
            this.animTimeDiff += (new Date().getTime() - this.animElapsedTime) / 1000;
            this.animTimeDiff = Math.min(this.animTimeDiff, action.getClip().duration);
            action.time = this.animTimeDiff;
        } else {
            if(this.animElapsedTime){
                this.animTimeDiff -= (new Date().getTime() - this.animElapsedTime) / 1000;
                this.animTimeDiff = Math.max(this.animTimeDiff, 0);
                action.time = this.animTimeDiff;
            }
        }

        const applyLightMap = function (lightMaps) {
            this.textureMeshes.forEach(obj => {
                obj.mesh.material.lightMap = lightMaps;
                obj.mesh.material.needsUpdate = false;
            });
        }.bind(this);

        const startAnimation = async function() {
            this.animElapsedTime = new Date().getTime();
            if(this.isAnimationDirectionForward) {
                new THREE.TextureLoader().loadAsync(this.props.selectedModel.lightMapPathAnim).then(lightMap => {
                    applyLightMap(lightMap);
								}).then(() => {
										action.play();
								});
            } else {
							action.play();
						}
        }.bind(this);

        console.log(`delta ${isDirectionForward ? '+' : '-'} `, this.animElapsedTime, this.animTimeDiff, this.isAnimationDirectionForward);
        this.lightMapActivator = setTimeout(() => {
            /*
            * we need to switch between lightMaps depending on whether sofa is folded-in or no
            * */
					if(!this.isAnimationDirectionForward) {
                new THREE.TextureLoader().loadAsync(this.props.selectedModel.lightMapPath).then(lightMap => {
                    applyLightMap(lightMap);
								});
            }
        }, this.animTimeDiff * 1000);

        startAnimation();
    };

    deactivateControls = () => {
        cancelAnimationFrame(this.animationID);
        this.animationID = null;
    };

    activateControls = () => {
        console.log('activateControls');
        if(this.stats){
            this.stats.update();
        }
        if (!this.animationID) {
            this.animationID = requestAnimationFrame(this.animate);
        }
    };

    animate = () => {
        if(this.stats){
            this.stats.update();
        }
        this.animationID = requestAnimationFrame(this.animate);
        let delta = this.clock.getDelta();
        if ( this.mixer ) this.mixer.update( delta );
        this.callRender();
    };

    callRender = () => {
        /*
        * easing effect is added https://discourse.threejs.org/t/solved-how-to-add-smooth-transition-to-three-js-orbital-camera/657/2
        * */
        this.renderer.render( this.scene, this.camera );
        this.labelRenderer.render( this.scene, this.camera );
        //this.camera.updateProjectionMatrix();
        this.controls.update();
    };

    handleWindowResize = () => {
        const width = parseInt(getComputedStyle(this.mount).width);
        const height = parseInt(width / Constants.DIMMENSIONS_RATIO);

        this.setDocumentVariable('--sizeW', width + 'px');
        this.setDocumentVariable('--sizeH', height + 'px');

        console.log(width + ' : : ' + height);

        this.camera.aspect = width / height;
        this.renderer.setSize( width, height );
        this.labelRenderer.setSize( width, height );

        this.camera.updateProjectionMatrix();
    };

    setDraggableId = (value) => {
        this.draggableId = value;
        //console.log('__ID__' + this.draggableId);
    };

    onBgImageIsLoaded = () => {
        this.scene.background = null;
        this.setState({
            isBgExist : true
        })
    };

    onZoomClick = (e) => {
        let value;
        switch (e.target.id) {
            case 'plusSign':
                value = this.initialZoomValue + this.zoomShift;
                break;
            case 'minusSign':
                value = this.initialZoomValue - this.zoomShift;
                break;
            default :
                break;
        }

        console.log(this.state.model3D.scale.x + ' : ' + value + ' : ' + this.state.model3D.scale.x * value + ' : ' + this.props.selectedModel.scaleFactor);

        if( this.state.model3D.scale.x * value >= 0.5 * this.props.selectedModel.scaleFactor &&
            this.state.model3D.scale.x * value <= 2 * this.props.selectedModel.scaleFactor){
            this.state.model3D.scale.multiplyScalar(value);
        }

        let minusIcon = document.querySelector( '#minusSign' );
        if(this.state.model3D.scale.x * value < 0.5 * this.props.selectedModel.scaleFactor){
            //disable minus icon
            minusIcon.classList.add( 'fa-disabled' );
        } else {
            minusIcon.classList.remove( 'fa-disabled' );
        }

        let plusIcon = document.querySelector( '#plusSign' );
        if(this.state.model3D.scale.x * value > 2 * this.props.selectedModel.scaleFactor){
            //disable plus icon
            plusIcon.classList.add( 'fa-disabled' );
        } else {
            plusIcon.classList.remove( 'fa-disabled' );
        }
    };

    saveScreenShot = (state, text) => {
        let objToSave = [];
        this.textureMeshes.map(function(obj) {
            console.log(obj.mesh.id + ' : ' + obj.mesh.name + ' : ' + this.baseTextureId);
            let textureObj = {
                name : obj.mesh.name
            };
            textureObj.textureId = Boolean(obj.textureId === -1) ? Number(this.baseTextureId) : obj.textureId;

            let observedTexture = textures.find((someTexture) => (Boolean(Number(someTexture.id) === Number(textureObj.textureId)) ? someTexture : null));
            textureObj.description = Boolean(observedTexture) ? observedTexture.description : '';

            objToSave.push(textureObj);
        }.bind(this));

        let stateObj = {
            firstName : state.firstName,
            telNum: state.telNum,
            email: state.email,
            message: state.message,
            modelName: this.props.selectedModel.name
        };
        objToSave.push(stateObj);

        CommonUtil.saveTargetByteArray(document.getElementById('wrapperContainer'), this.renderer, objToSave, text);
    };

    render() {
        return (
            <div id="canvasContainer"
                 className='mx-auto'
                 ref={ref => (this.mount = ref)}>

                <LoadingCircles/>
                <TwistSticker isShown={this.state.isTwistLabelVisible}/>
            </div>
        )
    }
}
export default CanvasModel
